import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Modal from 'components/Modal'

export const FacilitiesContainer = styled.div`
  width: 100%;
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
`

export const FacilitiesItemContainer = styled.div`
  display: flex;
`
export const FacilitiesTitle = styled.h1`
  margin: 0;
`
export const FacilitiesRedirect = styled(Link)`
  margin-block-start: 0.67em;
  margin-left: 25px;
  color: ${({ theme }) => theme.colors.primary};
`

export const FacilitiesCourtImageContainer = styled.div`
  position: absolute;
  right: 100px;
`
export const FacilitiesCourtImage = styled.img`
  object-fit: cover;
  width: 224px;
`
export const FacilitiesAddress = styled.div`
  margin-top: 15px;
  margin-bottom: 25px;
  color: ${({ theme }) => theme.colors.fontSecondary};
`
export const LocationIconContainer = styled.div`
  font-size: 1.5em;
  color: ${({ theme }) => theme.colors.primary};
  margin-top: 0.5em;
  margin-left: 0.35em;
`

export const FacilitiesCourtContainer = styled.div`
  display: flex;
  margin-top: 50px;
  align-items: center;
`
export const FacilitiesCourtItemContainer = styled.div`
  margin-left: 19px;
`
export const FacilitiesCourtCount = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 25px;
  margin-bottom: 15px;
`
export const FacilitiesCourtTitle = styled.h1`
  margin: 0;
  color: #1a1a1a;
  font-weight: 500;
  font-size: 28px;
`

export const FacilitiesModal = styled(Modal)`
  max-height: 750px;
`
